import { render, staticRenderFns } from "./UploadExperFile.vue?vue&type=template&id=c0b4ffe6&scoped=true"
import script from "./UploadExperFile.vue?vue&type=script&lang=js"
export * from "./UploadExperFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4ffe6",
  null
  
)

export default component.exports